import { DisplayTypeEnum } from "api/files";
import { GenericColors } from "api/tenant";
import { toasterService } from "components/feedback/Toaster/toasterService";
import { useDialog } from "hooks/useDialog";
import { FC, useEffect, useState } from "react";

import { realEstateAPI } from "services/swagger-api/realEstateAPI";
import { BienPicker } from "./BienPicker";

interface AddBienToParcModalProps {
  parcId: string;
  personId: string;
  onAdded: () => void;
}

export const AddBienToParcModal: FC<AddBienToParcModalProps> = ({ parcId, personId, onAdded }) => {
  const { setDialogActions, closeDialog } = useDialog();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (selectedIds.length === 0 || isSubmitting) return;
    setIsSubmitting(true);
    try {
      const response = await realEstateAPI.addBiensToParc({
        parcId,
        addBiensToParcCommand: { realEstateIds: selectedIds }
      });
      if (response.isSuccess) {
        toasterService.showToast({
          message: "Bien(s) ajouté(s) au parc.",
          displayType: DisplayTypeEnum.Toaster,
          color: GenericColors.Green
        });
        onAdded();
        closeDialog();
      } else {
        toasterService.showToast({
          message: response.errorMessage || "Erreur lors de l'ajout au parc.",
          displayType: DisplayTypeEnum.Toaster,
          color: GenericColors.Red
        });
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout de biens au parc:", error);
      toasterService.showToast({
        message: "Erreur lors de l'ajout au parc.",
        displayType: DisplayTypeEnum.Toaster,
        color: GenericColors.Red
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    setDialogActions({
      submitLabel: "COMMON.VALIDATE",
      closeLabel: "COMMON.CANCEL",
      submitDisabled: selectedIds.length === 0 || isSubmitting,
      onSubmit: handleSubmit
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIds, isSubmitting]);

  return <BienPicker personId={personId} excludeParcId={parcId} onSelectionChange={setSelectedIds} />;
};
